(function () {
  let cachedProductVariants = null;
  let hasForcedPlaceholder = false;

  function escapeSelector(value) {
    if (window.CSS?.escape) return CSS.escape(value);
    return value.replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
  }

  function getProductVariants() {
    if (cachedProductVariants) return cachedProductVariants;

    const script = document.querySelector('[data-product-variants-json]');
    if (!script) return [];

    try {
      cachedProductVariants = JSON.parse(script.textContent);
    } catch {
      cachedProductVariants = [];
    }

    return cachedProductVariants;
  }

  function getVariantSelectData(picker) {
    const variantSelect = picker.closest('.variant-selects');
    if (!variantSelect) return null;

    if (typeof Alpine !== 'undefined' && Alpine.$data) {
      try {
        return Alpine.$data(variantSelect);
      } catch (error) {
        // Fall through to Alpine internal stack.
      }
    }

    return variantSelect._x_dataStack?.[0] || null;
  }

  function getSessionSelect(picker) {
    return picker.querySelector('[data-workshop-session-select]');
  }

  function getSelectedSessionOption(select) {
    if (!select || select.selectedIndex < 0) return null;
    const option = select.options[select.selectedIndex];
    if (!option || !option.dataset.dateValue) return null;
    return option;
  }

  function findSessionInputs(picker, option) {
    let dateInput = null;
    let timeInput = null;

    if (option.dataset.dateInputId) {
      dateInput = picker.querySelector(`#${escapeSelector(option.dataset.dateInputId)}`);
    }
    if (option.dataset.timeInputId) {
      timeInput = picker.querySelector(`#${escapeSelector(option.dataset.timeInputId)}`);
    }

    if (!dateInput && option.dataset.dateOptionValueId) {
      dateInput = picker.querySelector(
        `input[type="radio"][data-option-value-id="${option.dataset.dateOptionValueId}"]`
      );
    }
    if (!timeInput && option.dataset.timeOptionValueId) {
      timeInput = picker.querySelector(
        `input[type="radio"][data-option-value-id="${option.dataset.timeOptionValueId}"]`
      );
    }

    if (!dateInput && option.dataset.dateInputName && option.dataset.dateValue) {
      dateInput = Array.from(picker.querySelectorAll('input[type="radio"]')).find(
        (input) => input.name === option.dataset.dateInputName && input.value === option.dataset.dateValue
      );
    }
    if (!timeInput && option.dataset.timeInputName && option.dataset.timeValue) {
      timeInput = Array.from(picker.querySelectorAll('input[type="radio"]')).find(
        (input) => input.name === option.dataset.timeInputName && input.value === option.dataset.timeValue
      );
    }

    return { dateInput, timeInput };
  }

  function selectRadioInput(picker, input) {
    if (!input || input.disabled) return false;

    const label = picker.querySelector(`label[for="${input.id}"]`);
    if (label) {
      label.click();
      return input.checked;
    }

    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function countSelectedOptions(picker) {
    return picker.querySelectorAll('fieldset[data-option-index] input[type="radio"]:checked:not(.disabled)').length;
  }

  function countTotalOptions(picker) {
    return picker.querySelectorAll('fieldset[data-option-index]').length;
  }

  function getCurrentSelections(picker) {
    const selections = {};

    picker.querySelectorAll('fieldset[data-option-index]').forEach((fieldset) => {
      const idx = parseInt(fieldset.dataset.optionIndex, 10);
      const checked = fieldset.querySelector('input[type="radio"]:checked:not(.disabled)');
      if (checked) selections[idx] = checked.value;
    });

    return selections;
  }

  function getVariantFromInput(picker, input) {
    const script = picker.querySelector(`script[type="application/json"][data-resource="${input.id}"]`);
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch {
      return null;
    }
  }

  function findVariantForSelections(picker, lampInput, pendingSelections) {
    const selections = pendingSelections || getCurrentSelections(picker);
    const selectedIndices = Object.keys(selections).map((idx) => parseInt(idx, 10));
    const optionCount = countTotalOptions(picker);
    const variants = getProductVariants();

    if (selectedIndices.length === optionCount) {
      const exact = variants.find((variant) =>
        variant.options.every((optionValue, idx) => selections[idx] === optionValue)
      );
      if (exact?.featured_media_id) return exact;
    }

    if (selectedIndices.length > 0) {
      const partial = variants.find((variant) => {
        if (!variant.featured_media_id) return false;
        return selectedIndices.every((idx) => variant.options[idx] === selections[idx]);
      });
      if (partial) return partial;
    }

    if (lampInput) {
      const fallback = getVariantFromInput(picker, lampInput);
      if (fallback?.featured_media?.id) {
        return { featured_media_id: fallback.featured_media.id };
      }
    }

    return null;
  }

  function triggerVariantUpdate(picker, input) {
    if (!input) return;

    const alpineData = getVariantSelectData(picker);
    if (alpineData?.updateVariantSelector) {
      alpineData.updateVariantSelector.call(alpineData, input.id, input.dataset.productUrl || '');
      return;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function goToVariantMedia(picker, variant) {
    const mediaId = variant?.featured_media?.id ?? variant?.featured_media_id;
    if (!mediaId) return;

    const sectionId = picker.id.replace('variant-update-', '');
    const slideVariant = document.getElementsByClassName(`${mediaId}-${sectionId}`);
    const index = parseInt(slideVariant[0]?.getAttribute('index'), 10);
    const splideEl = document.getElementById(`x-product-${sectionId}`);
    const activeEL = document.getElementById(`postion-image-${sectionId}-${mediaId}`);

    const goToSlide = () => {
      if (splideEl?.splide && !Number.isNaN(index)) {
        splideEl.splide.go(index);
      }
    };

    goToSlide();
    if (splideEl && !splideEl.splide) {
      document.addEventListener(`eurus:media-gallery-ready:${sectionId}`, goToSlide, { once: true });
    }

    const stackedEL = document.getElementById(`stacked-${sectionId}`);
    if (stackedEL && activeEL) {
      stackedEL.prepend(activeEL);
    }
  }

  function updateLampMedia(picker, lampInput, pendingSelections) {
    const variant = findVariantForSelections(picker, lampInput, pendingSelections);
    if (variant) goToVariantMedia(picker, variant);
  }

  function handleLampChange(input) {
    const picker = input.closest('.workshop-variant-picker');
    if (!picker) return;

    syncSessionSelect(picker);
    updateLampMedia(picker, input);

    if (countSelectedOptions(picker) >= countTotalOptions(picker)) {
      triggerVariantUpdate(picker, input);
    }
  }

  function syncSessionSelect(picker) {
    const select = getSessionSelect(picker);
    if (!select) return;

    const sessionPicker = picker.querySelector('[data-workshop-session-picker]');
    const fieldsets = sessionPicker?.querySelectorAll('fieldset[data-option-index]');
    const dateChecked = fieldsets?.[0]?.querySelector('input[type="radio"]:checked');
    const timeChecked = fieldsets?.[1]?.querySelector('input[type="radio"]:checked');

    Array.from(select.options).forEach((option) => option.removeAttribute('selected'));

    if (!dateChecked || !timeChecked) {
      select.value = '';
      const placeholder = select.querySelector('option[value=""]');
      if (placeholder) placeholder.setAttribute('selected', 'selected');
      return;
    }

    const match = Array.from(select.options).find(
      (option) =>
        option.dataset.dateValue === dateChecked.value && option.dataset.timeValue === timeChecked.value
    );

    if (match && !match.disabled) {
      select.value = match.value;
      match.setAttribute('selected', 'selected');
    } else {
      select.value = '';
      const placeholder = select.querySelector('option[value=""]');
      if (placeholder) placeholder.setAttribute('selected', 'selected');
    }
  }

  function handleSessionChange(select) {
    const picker = select.closest('.workshop-variant-picker');
    if (!picker) return;

    const option = getSelectedSessionOption(select);
    if (!option || option.disabled) return;

    const { dateInput, timeInput } = findSessionInputs(picker, option);
    if (!dateInput || !timeInput) return;

    selectRadioInput(picker, dateInput);
    selectRadioInput(picker, timeInput);
    syncSessionSelect(picker);

    if (countSelectedOptions(picker) >= countTotalOptions(picker)) {
      triggerVariantUpdate(picker, timeInput);
    }
  }

  function sortSessionOptions(picker) {
    const select = getSessionSelect(picker);
    if (!select) return;

    const placeholder = select.querySelector('option[value=""]');
    const options = Array.from(select.querySelectorAll('[data-workshop-session-option]'));
    options.sort((a, b) => {
      const dateA = new Date(a.dataset.sortDate || a.dataset.dateValue);
      const dateB = new Date(b.dataset.sortDate || b.dataset.dateValue);
      if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) return 0;
      return dateA - dateB;
    });

    options.forEach((option) => select.appendChild(option));
    if (placeholder) select.insertBefore(placeholder, select.firstChild);
  }

  function disableAddToCart(picker) {
    const sectionId = picker.id.replace('variant-update-', '');
    document.querySelectorAll(`#product-form-${sectionId}, #product-form-sticky-${sectionId}`).forEach((form) => {
      const addButton = form.querySelector('.add_to_cart_button');
      if (addButton) addButton.setAttribute('disabled', 'disabled');
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) variantInput.value = '';
    });

    const alpineData = getVariantSelectData(picker);
    if (alpineData) alpineData.currentVariant = null;
  }

  function clearDefaultSessionSelection(picker) {
    const select = getSessionSelect(picker);
    if (!select) return;

    const sessionPicker = picker.querySelector('[data-workshop-session-picker]');
    if (!sessionPicker) return;

    sessionPicker.querySelectorAll('fieldset[data-option-index] input[type="radio"]:checked').forEach((input) => {
      input.checked = false;
    });

    Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
    select.value = '';
    const placeholder = select.querySelector('option[value=""]');
    if (placeholder) placeholder.setAttribute('selected', 'selected');

    disableAddToCart(picker);
  }

  function initPicker(picker) {
    if (!picker || picker.dataset.workshopPickerInit === 'true') return;
    picker.dataset.workshopPickerInit = 'true';

    sortSessionOptions(picker);

    if (!hasForcedPlaceholder) {
      clearDefaultSessionSelection(picker);
      hasForcedPlaceholder = true;
    } else {
      syncSessionSelect(picker);
    }

    const select = getSessionSelect(picker);
    if (select) {
      select.addEventListener('change', () => handleSessionChange(select));
    }

    picker.querySelectorAll('[data-workshop-session-picker] fieldset input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => syncSessionSelect(picker));
    });

    const lampFieldset = picker.querySelector('[data-workshop-lamp-picker]');
    if (lampFieldset) {
      lampFieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.addEventListener('change', () => handleLampChange(input));
      });

      lampFieldset.querySelectorAll('label.workshop-lamp-swatch').forEach((label) => {
        label.addEventListener('mousedown', () => {
          const inputId = label.getAttribute('for');
          const input = inputId ? picker.querySelector(`#${escapeSelector(inputId)}`) : null;
          if (!input || input.disabled) return;

          const lampIndex = parseInt(lampFieldset.dataset.optionIndex, 10);
          const pendingSelections = getCurrentSelections(picker);
          pendingSelections[lampIndex] = input.value;
          updateLampMedia(picker, input, pendingSelections);
        });
      });
    }
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll('.workshop-variant-picker').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    cachedProductVariants = null;
    hasForcedPlaceholder = false;
    initAll(event.target);
  });

  window.xWorkshopVariantPicker = { initAll, syncSessionSelect, triggerVariantUpdate };
})();
